import en from 'commonAssets/i18n/en';
import merge from 'lodash.merge';

const overrides = {
    "claim_edit_instructions": "Please update any claim fields and then click Submit on the bottom of this page to update your Payment Form.",
    "claim_edit_notice": "Filed a claim? <a href=\"javascript:void(0);\" id=\"editClaimBtn\">Click here</a> to edit your claim.",
    "claim_edit_title": "Edit Payment Form",
    "claim_form_errors": "There are errors on the Payment Form.",
    "claim_submit_error": "There was an error submitting your payment form, please try again.",
    "claim_submit_success": "Thank you, your payment form has been submitted.",
    "confirmation_page": {
        "title": 'Your Payment Form has been submitted successfully.',
        "claim_details": {
            "title": 'Your Payment Details',
            "body": 'PAYMENT INFORMATION',
        },
    },
    "confirmation_this_is_a_copy": "THIS IS A COPY OF YOUR PAYMENT FORM",
    "confirmation_screen_additional": {
        "body": "<p class=\"fw-bold\">You will receive a confirmation and copy of your payment form via email, including your Submitted Payment ID and Confirmation Code. Do not share your Payment ID or Confirmation Code with others. We will never call you for this information.</p><p>You may also print this screen for your records.</p><p>If you don't receive a confirmation email after 3 days, please check your spam filter.</p>",
    },
    "contact_us_select_dropdown": {
        "claim_form": "Payment Form",
    },
    "deadline_claim": "The deadline to submit a Payment Form has passed.",
    "nav_submit_claim_button": "Submit Payment Form",
    "not_eligible_submit_claim": "You are not eligible to submit a payment form.",
    "otp_instructions_2": "Please enter the 6 digit code below to access your payment form.",
    "payment_select_email_disclaimer": "Please make sure the email or phone number you provide to receive payment matches your contact information above."
}

export default { en: merge(en, overrides) };
